import baseApiClient from '@cnd_fe/ky-client'

// 통계 API 클라이언트
const statsClient = baseApiClient.extend({
  prefixUrl: import.meta.env.VITE_RES_CMMN_SERVICE_URL
})

/**
 * 메뉴 접속수 카운트 (SPA 내비게이션용)
 * POST /api/v1/res/cmmn/redis-counter/menu
 * - Redis INCR → 스케줄러 배치 flush (DB 부하 분산)
 * - 기존: menu-counter/menuCount (DB 직접 MERGE)
 * @param {Object} payload
 * @param {string} payload.menuUrl  - 메뉴 URL (필수, max 500)
 * @param {string} payload.menuId   - 메뉴 아이디 (필수, max 60)
 * @returns {Promise<{ resultCode: string, resultMsg: string }>}
 */
export const countMenuAccess = (payload) => {
  return statsClient.post('redis-counter/menu', { json: payload }).json()
}
